import { fetchApi } from './api';

export const getLogStats = async () => {
  return fetchApi('/logs/stats', { method: 'GET' });
};

export const getActivityLogs = async ({ page = 1, limit = 25, userType = 'all', action = 'all', search = '' }) => {
  const params = new URLSearchParams();
  if (page) params.append('page', page);
  if (limit) params.append('limit', limit);
  if (userType && userType !== 'all') params.append('userType', userType);
  if (action && action !== 'all') params.append('action', action);
  if (search) params.append('search', search);

  return fetchApi(`/logs/activity?${params.toString()}`, { method: 'GET' });
};

export const getErrorLogs = async ({ page = 1, limit = 25, statusCode = 'all', search = '' }) => {
  const params = new URLSearchParams();
  if (page) params.append('page', page);
  if (limit) params.append('limit', limit);
  if (statusCode && statusCode !== 'all') params.append('statusCode', statusCode);
  if (search) params.append('search', search);

  return fetchApi(`/logs/errors?${params.toString()}`, { method: 'GET' });
};

export const purgeOldLogs = async () => {
  return fetchApi('/logs/purge', { method: 'POST' });
};
